module.exports = __webpack_public_path__ + "img/donante-justicia-social-tijuana.5ca4915e.png";